import { useMutation } from "@tanstack/react-query";
import { getOrderById, getOrdersByUser } from "../api";

export const useGetOrdersByUser = () => {
  const query = useMutation({
    mutationKey: ['useGetOrdersByUser'],
    mutationFn: getOrdersByUser,
    onSuccess: (status) => {
      return status;
    },
  });
  return query;
};

export const useGetOrderById = () => {
  const query = useMutation({
    mutationKey: ['useGetOrderById'],
    mutationFn: getOrderById,
    onSuccess: (status) => {
      return status;
    },
  });
  return query;
};